import APIService from '../../services/APIService';
import { FSAInterface } from '../actions';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from '../../environments/environment';
import { Apis } from '../../constants';

const _REQUEST = '_REQUEST';
const _SUCCESS = '_SUCCESS';
const _FAILURE = '_FAILURE';

/*
  dispatch({
    type: ADD_GEOTAG_URL_REQUEST,
    payload: { url },
    meta: {
      url: `/board/${boardId}/geolocation`,
      method: 'POST',
    }
  })
*/

export default () => (next: Function) => async (action: FSAInterface<any>) => {
  const { type, payload, meta = {} } = action;
  const { isOptimistic, method, url, additionalAsync, api = Apis.CORE, ...metaRest } = meta;

  if (!meta || !url || !method) return next(action);

  next({ type, payload, meta });

  try {
    if (meta.formData) {
      // TODO: Make sure this works. Also appears in src/services/APIService.ts
      const authToken = (await fetchAuthSession()).tokens?.idToken?.toString() || '';
      const headers = {
        Authorization: authToken,
      };
      const envUrl = environment.localApi ? environment.localApi : environment.coreApiUrl;
      const data = await fetch(`${envUrl}${url}`, { method, body: payload as any, headers });
      const post = await data.json();
      if (!data.ok) {
        return next({
          type: type.replace(_REQUEST, _FAILURE),
          payload: data.statusText,
          errorObj: post,
          error: true,
          meta: metaRest,
        });
      }
      return next({
        type: type.replace(_REQUEST, _SUCCESS),
        payload: post,
        meta: metaRest,
      });
    }
    const data = await APIService[method](url, api, payload);
    const result = method === 'PUT' && !environment.localApi ? data : data.data;
    if (additionalAsync) {
      const processedResults = await additionalAsync(result, payload, url);
      return next({
        type: type.replace(_REQUEST, _SUCCESS),
        payload: processedResults,
        meta: metaRest,
      });
    }
    return next({
      type: type.replace(_REQUEST, _SUCCESS),
      payload: result,
      meta: metaRest,
    });
  } catch (err) {
    return next({
      type: type.replace(_REQUEST, _FAILURE),
      payload: err,
      error: true,
      meta: metaRest,
    });
  }
};
